import { render, staticRenderFns } from "./GoogleSpreadsheetFileDetail.vue?vue&type=template&id=2764d37c&scoped=true"
import script from "./GoogleSpreadsheetFileDetail.vue?vue&type=script&lang=ts"
export * from "./GoogleSpreadsheetFileDetail.vue?vue&type=script&lang=ts"
import style0 from "./GoogleSpreadsheetFileDetail.vue?vue&type=style&index=0&id=2764d37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2764d37c",
  null
  
)

export default component.exports